<template>
  <div class="coupon-autocomplete-container">
    <el-autocomplete
      popper-class="coupon-el-popper-class"
      class="coupon-el-autocomplete"
      :value="promoCode"
      :popper-append-to-body="false"
      @input="promoCodeChange"
      @select="promoCodeSelect"
      :fetch-suggestions="querySearchPromoCode"
      :placeholder="$t('enter_coupon_code')"
      :trigger-on-focus="true">
      <template slot-scope="{ item }">
        <div class="coupon-card-container">
          <div class="coupon-card-top-container">
            <span>{{item.PromoCode}}</span>
            <div class="coupon-expires">
              {{ $t('expires') }}: {{getExpireDate(item.EndDate)}}
            </div>
          </div>
          <div class="coupon-info">
            <p>{{item.Name}}</p>
            <p>{{item.DiscountDescription}}</p>
          </div>
        </div>
      </template>
    </el-autocomplete>
  </div>
</template>

<script>
import {promoCodeList} from "../../mixin";

export default {
  name: "coupon-autocomplete",
  mixins: [promoCodeList],
  model: {
    prop: 'promoCode',
    event: 'change'
  },
  props: {
    promoCode: String
  },
  data() {
    return {}
  },
  methods: {
    promoCodeChange(value) {
      this.$emit('change', value)
    },
    promoCodeSelect(item) {
      this.promoCodeChange(item.PromoCode)
    }
  }
}
</script>

<style lang="less">
.coupon-autocomplete-container {
  .coupon-el-popper-class {
    width: auto !important;

    .coupon-card-container {
      font-family: 'Source Sans Pro';
      font-size: 12px;
      line-height: 1.2;
      padding: 5px 0;

      .coupon-card-top-container {
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
          color: #E9C34B;
        }
      }

      .coupon-info {
        color: #8ba39e;
        font-weight: 600;
      }

      .coupon-expires {
        color: #8ba39e;
        font-weight: 300;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupon-autocomplete/coupon-autocomplete.vue